import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const l = t((o, r) => /* @__PURE__ */ e.jsx(
  i,
  {
    ref: r,
    ...o,
    image: (a) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...a,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M5 7.252c0 .569-.262 1.097-.603 1.552a4.5 4.5 0 1 0 7.206 0C11.262 8.349 11 7.82 11 7.252V3a3 3 0 0 0-6 0zM8 2a1 1 0 0 0-1 1v4h2V3a1 1 0 0 0-1-1",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
l.displayName = "TemperatureIcon";
export {
  l as TemperatureIcon,
  l as default
};
//# sourceMappingURL=index.js.map
